export default function JSBBCCMembership() {
    return (
<div>
 <h4>Members</h4>
<hr/>
                <p>
                  <b>Helen Hlahol</b>
                  <br/>                  
                </p>
                <p>
                  <b>Peggy Walsh</b>
                  <br/>
                </p>
                 <p>
                  <b>Gary Wallace</b>
                  <br/>  
                </p>
                
               
                </div>
                )
            }